var path = '/templates/projects.segments/campaign_segment_show_cv_users.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowCvUsers.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td>{{ 'projectsSegments.campaignSegmentShowCvUsers.kako_no_kounyuu' | translate }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/campaign_segment_show_cv_users.html
// module id = 1445
// module chunks = 0